module.exports = __webpack_public_path__ + "cab86c4f1a7ff3ce0f83f06afdd8767a.pdf";